<template>
  <div>
    <template v-if="highlight_period">
      <b-list-group>
        <b-list-group-item
          class="choose-day cursor-pointer"
          @click="sendDate(getDateByDayWithoutWeekend(1))"
          >{{$t('SCHEDULE_NEWS.One_Day')}} <span>{{ formatDate(getDateByDayWithoutWeekend(1), {dateStyle: "medium",timeStyle: "short",}) }}</span></b-list-group-item
        >
        <b-list-group-item
          class="choose-day cursor-pointer"
          @click="sendDate(getDateByDayWithoutWeekend(2))"
          >{{$t('SCHEDULE_NEWS.Two_Days')}} <span>{{ formatDate(getDateByDayWithoutWeekend(2), {dateStyle: "medium",timeStyle: "short",}) }}</span></b-list-group-item
        >
        <b-list-group-item
          class="choose-day cursor-pointer"
          @click="sendDate(getDateByDayWithoutWeekend(5))"
          >{{$t('SCHEDULE_NEWS.Five_Days')}} <span>{{ formatDate(getDateByDayWithoutWeekend(5), {dateStyle: "medium",timeStyle: "short",}) }}</span></b-list-group-item
        >
        <b-list-group-item
          class="choose-day cursor-pointer"
          @click="sendDate(getDateByDayWithoutWeekend(7))"
          >{{$t('SCHEDULE_NEWS.One_Week')}} <span>{{ formatDate(getDateByDayWithoutWeekend(7), {dateStyle: "medium",timeStyle: "short",}) }}</span></b-list-group-item
        >
        <b-list-group-item
          class="choose-day cursor-pointer"
          @click="sendDate(getDateByMonth(1))"
          >{{$t('SCHEDULE_NEWS.One_Month')}} <span>{{ formatDate(getDateByMonth(1), {dateStyle: "medium",timeStyle: "short",}) }}</span></b-list-group-item
        >
        <b-list-group-item class="choose-day cursor-pointer custom-date">
          {{$t('SCHEDULE_NEWS.Select_Date')}}
          <flat-pickr
            v-model="highlight_custom_date"
            class="form-control input-dt-schedule"
            :config="{
            enableTime: false,
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'd/m/Y',
          }"
          @input="onSelectDate"
        />
        </b-list-group-item
        >
      </b-list-group>

      <!-- <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="chooseByCalendar = !chooseByCalendar"
      >
        <feather-icon icon="CalendarIcon" size="16" />
      Selecionar
      </b-button> -->
    </template>

    <template v-if="inLive_period">
      <b-list-group>
        <b-list-group-item
          class="choose-day cursor-pointer"
          @click="sendDate(getDateByMinutes(30))"
          >{{$t('SCHEDULE_NEWS.Thirty_Minutes')}} <span>{{ formatDate(getDateByMinutes(30), {dateStyle: "medium",timeStyle: "short",}) }}</span></b-list-group-item
        >
        <b-list-group-item
          class="choose-day cursor-pointer"
          @click="sendDate(getDateByHour(1))"
          >{{$t('SCHEDULE_NEWS.One_Hour')}} <span>{{ formatDate(getDateByHour(1), {dateStyle: "medium",timeStyle: "short",}) }}</span></b-list-group-item
        >
        <b-list-group-item
          class="choose-day cursor-pointer"
          @click="sendDate(getDateByHour(2))"
          >{{$t('SCHEDULE_NEWS.Two_Hours')}} <span>{{ formatDate(getDateByHour(2), {dateStyle: "medium",timeStyle: "short",}) }}</span></b-list-group-item
        >
        <b-list-group-item
          class="choose-day cursor-pointer"
          @click="sendDate(getDateByHour(3))"
          >{{$t('SCHEDULE_NEWS.Three_Hours')}} <span>{{ formatDate(getDateByHour(3), {dateStyle: "medium",timeStyle: "short",}) }}</span></b-list-group-item
        >
        <b-list-group-item
          class="choose-day cursor-pointer"
          @click="sendDate(getDateByHour(5))"
          >{{$t('SCHEDULE_NEWS.Five_Hours')}} <span>{{ formatDate(getDateByHour(5), {dateStyle: "medium",timeStyle: "short",}) }}</span></b-list-group-item
        >
        <b-list-group-item
          class="choose-day cursor-pointer"
          @click="sendDate(getDateByDayWithoutWeekend(1))"
          >{{$t('SCHEDULE_NEWS.One_Day')}} <span>{{ formatDate(getDateByDayWithoutWeekend(1), {dateStyle: "medium",timeStyle: "short",}) }}</span></b-list-group-item
        >
      </b-list-group>
    </template>

    <template v-if="false">
      <h4 class="">{{$t('SCHEDULE_NEWS.ChooseDtHr')}}</h4>
      <div class="d-flex text-center">
        <div>
          <flat-pickr
            v-model="dt_duration_calendar"
            class="form-control input-dt-schedule"
            :config="{
              enableTime: false,
              dateFormat: 'Y-m-d',
              altInput: true,
              altFormat: 'd/m/Y',
              allowInput: true,
              inline: true,
            }"
          />
        </div>
        <div class="form-label-group modal-input-schedule">
          <cleave
            id="hour_duration_calendar"
            v-model="hour_duration_calendar"
            class="form-control"
            :raw="false"
            :options="maskOptions.time"
            placeholder="hh:mm"
          />
        </div>
      </div>

      <b-button
        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
        variant="flat-secondary"
        @click="chooseByCalendar = !chooseByCalendar"
      >
        {{$t('SCHEDULE_NEWS.Back')}}
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="selectDateCalendar()"
      >
        {{$t('SCHEDULE_NEWS.Select_Date')}}
      </b-button>
    </template>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import Cleave from "vue-cleave-component";
import formatFieldHelper from "@/helpers/format-field-helper";
import { formatDate } from "@core/utils/filter";
import { BButton, BListGroup, BListGroupItem } from "bootstrap-vue";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';

export default {
  props: {
  },
  data() {
    return {
      chooseByCalendar: false,
      dt_duration_calendar: "",
      hour_duration_calendar: "",
      maskOptions: {
        time: {
          time: true,
          timePattern: ["h", "m"],
        },
        date: {
          date: true,
          delimiter: "/",
          // datePattern: ['d', 'm', 'Y'],
          datePattern: ["Y", "m", "d"],
        },
      },
      field: "",
      highlight_period: false,
      inLive_period: false,
      highlight_custom_date: ""
    };
  },
  computed: {
  },
  created() {
    const nextHour = formatFieldHelper.getNextHourDate();
    this.dt_duration_calendar = formatFieldHelper.getDtformated(nextHour);
    this.hour_duration_calendar = formatFieldHelper.getHourformated(nextHour);
  },
  methods: {
    getDateByMinutes(min) {
      const dt = new Date();
      dt.setMinutes(dt.getMinutes() + min);
      return dt;
    },
    getDateByHour(hours) {
      const dt = new Date();
      dt.setHours(dt.getHours() + hours);
      return dt;
    },
    getDateByDay(days) {
      const dt = new Date();
      dt.setDate(dt.getDate() + days);
      return dt;
    },
    getDateByDayWithoutWeekend(days) {
      const dt = new Date();
      dt.setDate(dt.getDate() + days);
      if (!convertDatetimeHelper.isDateWeekend(dt)) return dt;
      const newDate = convertDatetimeHelper.getNextDateWithoutWeekend(dt);
      return newDate;
    },
    getDateByMonth(months) {
      const dt = new Date();
      dt.setMonth(dt.getMonth() + months);
      return dt;
    },
    sendDate(dt) {
      this.emitDate(this.getShortFormatDate(dt));
    },
    getShortFormatDate(dt) {
      return formatDate(dt, {dateStyle: "short",timeStyle: "short"});
    },
    selectDateCalendar() {
      this.emitDate(`${this.dt_duration_calendar} ${this.hour_duration_calendar}`);
    },
    emitDate(dt) {
      this.$emit("select-date", {date: dt, field: this.field});
    },
    setField(field) {
      console.log('field: ', field);
      this.field = field;
    },
    onSelectDate() {
      console.log('onSelectDate');
      console.log(convertDatetimeHelper.getDateWithLastHour(this.highlight_custom_date));
      this.emitDate(this.getShortFormatDate(convertDatetimeHelper.getDateWithLastHour(this.highlight_custom_date)));
    }
  },
  directives: {
    Ripple,
  },
  components: {
    BButton,
    flatPickr,
    Cleave,
    BListGroup,
    BListGroupItem,
  },
  setup() {
    // const getOneDay = () => {

    // };
    return {
      formatDate,
    };
  },
};
</script>

<style lang="scss">
.choose-day {
  display: flex;

  span {
    position: absolute;
    right: 55px;
  }
  
}
.choose-day.custom-date {
    display: block;
    .input-dt-schedule {
      width: 150px;
      display: inherit;
      float: right;
      margin-right: 30px;
    }
  }
</style>